import { Controller } from 'stimulus';

const HIDDEN_CLASS = 'hidden'

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0;
      var v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
}

export default class extends Controller {
  static targets = [
		'newListenerTemplate',
  ];

  onAddListener() {
    const content = this.newListenerTemplateTarget.innerHTML.replace(/idTemplate/g, generateUUID().slice(0, 6))
    this.element.innerHTML = content + this.element.innerHTML
  }

  onDeleteListener(event) {
    this.#listenerEl(event.target).remove()
  }

  onToggleOauthSettings(event) {
    const classList = this.#listenerEl(event.target).querySelector('.oauth-settings-fields').classList
    if (!classList) {
      return
    }
    classList.contains(HIDDEN_CLASS) ? classList.remove(HIDDEN_CLASS) : classList.add(HIDDEN_CLASS)
  }

  #listenerEl(childEl) {
    return childEl.closest('.listener-fields')
  }
}
